import { useMemo } from 'react'

import { Modal } from '../Modal'
import { ReactivateUserForm } from 'Components/Modal/ReactivateUserModal/ReactivateUserForm'
import { ModalHeader } from 'Components/Modal/ModalHeader'

import { ModalType, usePeoplePageContext } from 'Contexts/PeoplePageContext'
import { useEmployerUsersContext } from 'Contexts/EmployerUsersContext'

import { FlexColumn } from 'Utils/styles/spacing'
import { MediumBoldText, ThinDarkGreenText } from 'Utils/styles/text'

export const ReactivateUserModal = () => {
  const {
    state: { modal, actionableUserId },
    setModal
  } = usePeoplePageContext()

  const {
    state: { users }
  } = useEmployerUsersContext()

  const user = useMemo(() => {
    return users.find((user) => user.id == actionableUserId)
  }, [users, actionableUserId])

  const setShowModal = (show: boolean) => setModal(show ? ModalType.ReactivateUser : undefined)

  return (
    <Modal showModal={modal === ModalType.ReactivateUser} setShowModal={setShowModal}>
      <ModalHeader>Re-enable User</ModalHeader>

      <FlexColumn>
        <MediumBoldText>
          {user?.userInfo.firstName} {user?.userInfo.lastName}
        </MediumBoldText>
        <ThinDarkGreenText>{user?.userInfo.email}</ThinDarkGreenText>
      </FlexColumn>

      <ReactivateUserForm user={user} />
    </Modal>
  )
}
